module.exports = __webpack_public_path__ + "static/media/blog.zenmasaza.com.ca14a212.png";